import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

export function photoSrc(url) {
  if (!url) return null;
  return url.startsWith("/") ? `${API}${url}` : url;
}

// Avatar de la carte : le membre ajoute / change / retire sa photo (reconnaissance à l'accueil).
export function PassPhoto({ token, data, onChange }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const src = photoSrc(data.photo_url);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data: r } = await axios.post(`${API}/api/public/member-pass/${token}/photo`, fd);
      onChange(r.photo_url);
      toast.success("Photo ajoutée à ta carte 📸");
    } catch (e) { toast.error(e.response?.data?.detail || "Envoi de la photo impossible"); }
    finally { setBusy(false); if (inputRef.current) inputRef.current.value = ""; }
  };

  const remove = async () => {
    if (!window.confirm("Retirer ta photo de la carte ?")) return;
    try { await axios.delete(`${API}/api/public/member-pass/${token}/photo`); onChange(null); toast.success("Photo retirée"); }
    catch { toast.error("Erreur"); }
  };

  return (
    <div className="flex flex-col items-center mb-3" data-testid="pass-photo">
      <button onClick={() => inputRef.current?.click()} disabled={busy} data-testid="pass-photo-btn"
        className="relative w-24 h-24 rounded-full border-2 border-amber-700 overflow-hidden bg-amber-900/40 group disabled:opacity-60"
        title={src ? "Changer ma photo" : "Ajouter ma photo"}>
        {src ? (
          <img src={src} alt={data.name} className="w-full h-full object-cover" data-testid="pass-photo-img" />
        ) : (
          <span className="w-full h-full flex items-center justify-center text-3xl font-bold text-amber-300">{(data.name || "?").charAt(0)}</span>
        )}
        <span className="absolute inset-x-0 bottom-0 bg-black/70 text-[10px] text-white py-1 flex items-center justify-center gap-1">
          {busy ? "…" : <>📷 {src ? "Changer" : "Ajouter"}</>}
        </span>
      </button>
      <input ref={inputRef} type="file" accept="image/*" capture="user" className="hidden" data-testid="pass-photo-input"
        onChange={(e) => upload(e.target.files?.[0])} />
      {!src && <div className="text-[11px] text-zinc-500 mt-1.5">Ajoute ta photo : l'accueil te reconnaît d'un coup d'œil</div>}
      {src && <button onClick={remove} data-testid="pass-photo-remove" className="text-[11px] text-zinc-500 hover:text-red-300 mt-1">Retirer la photo</button>}
    </div>
  );
}
